import { saveOrderExtraVlaues, getB3OrderFiles, getB3OrderExtras, getDefaultB3OrderExtrasVal, validateOrderExtraFields } from './order'
import { setGoBackEcho, setDefaultAddress, getDefaultB3AddressExtrasVal, getB3ShippingAddressExtras, getB3BillingAddressExtras, saveExtrasAddress, billingSameAsShippingAddress, setAddressExtrasFiles, setAddressSelectExtrasFiles, isValidExtrasFiles } from './address'
import { getB3FormFieldsValidationSchema, getTranslateAddressError } from './validate'

import request from '../request'
import { conversionData, decodeExtraFieldsKeys } from './utils'
import { storage } from '../utils'
import { cloneDeep } from 'lodash';
import Base64 from '../utils/base64'


const getB3AddressFiles = async () => {

  const { list }: any = await request.api.getExtraFieldsModule('address')
  if (list && list.length) {
    const addressConversion = conversionData(list, false)

    const billingFields = cloneDeep(addressConversion)
    const shippingFields = cloneDeep(addressConversion)

    const B3BillingAddressExtras = getB3BillingAddressExtras()
    const B3ShippingAddressExtras = getB3ShippingAddressExtras()

    storage.B3DefaultAddressExtras.setValue(JSON.stringify(addressConversion))
    // Is not equal to zero, refresh...
    if (addressConversion.length === 0) {
      storage.B3BillingAddressExtras.setValue(JSON.stringify([]))
      storage.B3ShippingAddressExtras.setValue(JSON.stringify([]))
    } else {
      addressConversion.forEach((item: any, index: number) => {
        const billingList = B3BillingAddressExtras.find((v: any) => item.name === v.name && item.fieldType === v.fieldType && item.type === v.type)
        if (billingList) {
          billingFields[index].val = billingList.val
          billingFields[index].default = billingList.val
        }
        const shippingList = B3ShippingAddressExtras.find((v: any) => item.name === v.name && item.fieldType === v.fieldType && item.type === v.type)
        if (shippingList) {
          shippingFields[index].val = shippingList.val
          shippingFields[index].default = shippingList.val
        }
      })

      storage.B3BillingAddressExtras.setValue(JSON.stringify(billingFields))
      storage.B3ShippingAddressExtras.setValue(JSON.stringify(shippingFields))
    }
  }
}

const convertExtras = (addressExtras: any) => {
  const newAddressExtras: any = []
  if (addressExtras && addressExtras.length) {
    addressExtras.forEach((address: any) => {
      newAddressExtras.push({
        fieldName:  Base64.decode(address.name),
        fieldValue: address.val
      })
    })
  }
  return newAddressExtras
}

const getShippingAndBillingFields = () => {
  const shippingAddressExtras = JSON.parse(localStorage.getItem('B3ShippingCustomFields') || '[]')
  const billingAddressExtras = JSON.parse(localStorage.getItem('B3BillingCustomFields') || '[]')
  const newShippingAddressExtras = [...convertExtras(shippingAddressExtras)]
  const newBillingAddressExtras = [...convertExtras(billingAddressExtras)]
  const extraInfo: any = {}
  if (newShippingAddressExtras.length || newBillingAddressExtras.length) {
    extraInfo.addressExtraFields = {
      shippingAddressExtraFields: newShippingAddressExtras,
      billingAddressExtraFields: newBillingAddressExtras
    }
  }
  return extraInfo
}

const saveAddressExtrasFiles = () => {
  const shippingAddressExtras = getB3ShippingAddressExtras()
  const billingAddressExtras = getB3BillingAddressExtras()
  if ((shippingAddressExtras && shippingAddressExtras.length) || (billingAddressExtras && billingAddressExtras.length)) {
    localStorage.setItem('B3ShippingCustomFields', JSON.stringify(shippingAddressExtras || []))
    localStorage.setItem('B3BillingCustomFields', JSON.stringify(billingAddressExtras || []))
  }
}


const decodeAddressExtraFieldsKeys = (b2bCustomFields: any) => {
  return decodeExtraFieldsKeys(b2bCustomFields)
}

export default {
  getB3OrderFiles,
  getB3OrderExtras,
  getTranslateAddressError,
  getDefaultB3OrderExtrasVal,
  validateOrderExtraFields,
  // addresses
  setGoBackEcho,
  setDefaultAddress,
  getB3AddressFiles,
  getDefaultB3AddressExtrasVal,
  getB3ShippingAddressExtras,
  getB3BillingAddressExtras,
  saveExtrasAddress,
  billingSameAsShippingAddress,
  setAddressExtrasFiles,
  setAddressSelectExtrasFiles,
  isValidExtrasFiles,
  decodeAddressExtraFieldsKeys,
  // validate
  getB3FormFieldsValidationSchema,
  getShippingAndBillingFields,
  saveAddressExtrasFiles,
  saveOrderExtraVlaues,
}
